export const getProject = (state) => state.project
export const getProjectLoading = (state) => state.project.loading
export const getProjectData = (state) => state.project.projectData
export const getErrorMessage = (state) => state.project.errorMessage
